/* ============================================================
   efp2 — Your list（心願清單）v1
   Ben 2026-10-16 決定：純網站版（唔綁客人帳戶）
   * 心心存喺客人自己部機（localStorage），冇 cookie／清瀏覽器就會冇
   * 撳心心 = 儲起款式；header 有個 ♥ 掣開名單面板
   * 唔會出現喺客人 Shopify 帳戶頁（帳戶頁喺 shopify.com，讀唔到本機資料）
   ============================================================ */
(function () {
  'use strict';

  var KEY = 'efp2_wishlist_v1';
  var CACHE = 'efp2_wishlist_cache_v1';

  /* ---------- 讀寫本機名單 ---------- */
  function readList() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) { return []; }
  }
  function writeList(a) {
    try {
      localStorage.setItem(KEY, JSON.stringify(a));
      window.dispatchEvent(new CustomEvent('efp2-wishlist-change'));
    } catch (e) { /* 私密瀏覽等情況：靜靜失敗 */ }
  }
  function has(h) { return readList().indexOf(h) !== -1; }
  /* GA4：客人「加入」心願清單時報一個事件（只報款式，唔記名）。
     要喺 GA4 後台加一個自訂維度 product 先分得出邊款——詳見 vault。 */
  function reportAdd(handle) {
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'add_to_wishlist', { product: handle, item_id: handle, currency: 'USD' });
      }
    } catch (e) { /* 冇 GA4 就靜靜唔報 */ }
  }
  function toggle(h) {
    var a = readList(), i = a.indexOf(h);
    if (i === -1) { a.unshift(h); } else { a.splice(i, 1); }
    writeList(a);
    if (i === -1) { reportAdd(h); }
    return i === -1;
  }

  /* ---------- 產品資料（/products/<handle>.js，session 內快取）---------- */
  var mem = {};
  function productData(handle, cb) {
    if (mem[handle]) { cb(mem[handle]); return; }
    var cached = null;
    try { var c = JSON.parse(sessionStorage.getItem(CACHE) || '{}'); cached = c[handle] || null; } catch (e) {}
    if (cached) { mem[handle] = cached; cb(cached); return; }
    fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d) { cb(null); return; }
        var img = (d.featured_image || (d.images && d.images[0]) || '');
        if (img && img.indexOf('//') === 0) { img = 'https:' + img; }
        var info = {
          handle: handle,
          title: d.title || handle,
          url: '/products/' + handle,
          image: img.replace(/(\.(jpg|jpeg|png|webp))(\?|$)/i, '_300x$1$3'),
          price: 'US$' + (d.price / 100).toFixed(2)
        };
        if (d.compare_at_price && d.compare_at_price > d.price) {
          info.compare = 'US$' + (d.compare_at_price / 100).toFixed(2);
        }
        mem[handle] = info;
        try {
          var c2 = JSON.parse(sessionStorage.getItem(CACHE) || '{}');
          c2[handle] = info;
          sessionStorage.setItem(CACHE, JSON.stringify(c2));
        } catch (e) {}
        cb(info);
      })
      .catch(function () { cb(null); });
  }

  /* ---------- SVG ---------- */
  function heartSVG(filled) {
    return '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" ' +
      (filled ? 'fill="currentColor" stroke="currentColor"' : 'fill="none" stroke="currentColor"') +
      ' stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">' +
      '<path d="M12 20.5s-7.5-4.6-7.5-9.6A4.4 4.4 0 0 1 12 8.2a4.4 4.4 0 0 1 7.5 2.7c0 5-7.5 9.6-7.5 9.6z"/></svg>';
  }

  /* ---------- 樣式（跟主題 CSS 變數，黑白兩套色都夾）---------- */
  var CSS = '' +
    /* v4：心心色統一——主題有條 `[data-text-color="body"] button…` 規則會蓋過我哋（產品頁心心變黑白），
       所以心心顏色一律用 !important 由我哋話事；色值放喺變數，日後改一款色只改一處。 */
    ':root{--efp2-wl-fill:#B08D57}' +
    'html[data-efp2-scheme="dark"]{--efp2-wl-fill:#E3C88E}' +
    '.efp2-wl-heart{position:absolute;top:10px;right:10px;z-index:4;width:36px;height:36px;display:flex;align-items:center;' +
    'justify-content:center;border:0;border-radius:999px;padding:0;cursor:pointer;color:var(--color--body,#111) !important;' +
    'background:var(--bg-color--body-translucent,rgba(255,255,255,.85));backdrop-filter:blur(4px);transition:transform .15s ease}' +
    '.efp2-wl-heart:hover{transform:scale(1.08)}' +
    /* v2：商品卡心心改放喺產品名／價錢嘅右手邊（相下面嘅資料列右下角），唔再疊喺相度。
       絕對定位喺資料列（details）＝主題原有文字排版、行距、卡高度一律唔變。
       v3：加淡灰圓底（Ben 想試嘅款）＋ 產品頁同一款心心。 */
    '.efp2-wl-heart.efp2-wl-card{position:absolute;right:0;bottom:0;z-index:2;width:30px;height:30px;' +
    'border-radius:999px;background:rgba(128,128,128,.13);backdrop-filter:none;margin:0;padding:0;opacity:.75}' +
    '.efp2-wl-heart.efp2-wl-card[aria-pressed="true"]{opacity:1}' +
    '.product-card--details.efp2-wl-details{position:relative}' +
    '.efp2-wl-pdhost{position:relative}' +
    '.product-card--root[data-text-layout=right] .efp2-wl-details .efp2-wl-card{right:auto;left:0}' +
    '.efp2-wl-heart[aria-pressed="true"]{color:var(--efp2-wl-fill,#8E3B46) !important}' +
    '.efp2-wl-inline{position:static;display:inline-flex;width:auto;height:auto;gap:8px;padding:6px 10px;border:1px solid var(--border--color-light,rgba(0,0,0,.2));' +
    'border-radius:var(--button--radius,4px);background:transparent;font:inherit;font-size:13px;letter-spacing:.02em}' +
    '.efp2-wl-header{position:relative;display:inline-flex;align-items:center;justify-content:center;width:34px;height:34px;border:0;' +
    'background:transparent;color:inherit;cursor:pointer;padding:0}' +
    '.efp2-wl-count{position:absolute;top:-2px;right:-4px;min-width:15px;height:15px;border-radius:999px;background:var(--efp2-wl-fill,#B08D57) !important;' +
    'color:#1b1b1b !important;font-size:9px;line-height:15px;text-align:center;padding:0 3px;font-weight:600}' +
    /* v5：手機頭部原本已經塞滿（漢堡／搜尋／logo／日夜掣／帳戶／購物袋）——多一粒 34px 心心會令成頁闊 50px，
       客人要縮細先睇到。做法跟返主題自己喺 ≤380px 嘅做法（縮細日夜掣＋收窄間距），令所有掣平均向左移。
       實測（390px 機）：全頁 394px（原本 443）、四個掣間距一律 9px、心心同數字完整入畫面。 */
    /* v6：日夜掣搬去左邊（見 JS layoutHeader），右邊三個掣（帳戶／購物袋／心心）有返正常間距 */
    '@media only screen and (max-width: 767px){' +
    '.efp2-wl-header{width:26px;height:26px}' +
    '.efp2-wl-count{right:0;top:-4px;min-width:14px;height:14px;line-height:14px;font-size:8px}' +
    '.header--secondary-nav{gap:14px}' +
    'button.header--scheme{margin:0 0 0 2px}' +
    '.efp2-switch{width:46px;height:26px}' +
    '.efp2-knob{width:20px;height:20px;top:2px;left:2px}' +
    '.efp2-knob svg{width:12px;height:12px}' +
    'html[data-efp2-scheme="dark"] .efp2-knob{transform:translateX(20px) !important}' +
    '}' +
    '.efp2-wl-count[hidden]{display:none}' +
    '.efp2-wl-overlay{position:fixed;inset:0;background:rgba(0,0,0,.45);opacity:0;visibility:hidden;transition:opacity .2s ease;z-index:9998}' +
    '.efp2-wl-overlay.is-open{opacity:1;visibility:visible}' +
    '.efp2-wl-panel{position:fixed;top:0;right:0;height:100%;width:min(400px,92vw);max-width:100%;background:var(--bg-color--body,#fff);' +
    'color:var(--color--body,#111);z-index:9999;transform:translateX(102%);transition:transform .25s ease;display:flex;flex-direction:column;' +
    'box-shadow:var(--box-shadow--left,-8px 0 24px rgba(0,0,0,.12))}' +
    '.efp2-wl-panel.is-open{transform:translateX(0)}' +
    '.efp2-wl-head{display:flex;align-items:center;justify-content:space-between;padding:18px 20px;border-bottom:1px solid var(--border--color-light,rgba(0,0,0,.12))}' +
    '.efp2-wl-head h2{margin:0;font-size:13px;letter-spacing:.14em;text-transform:uppercase;font-weight:500}' +
    '.efp2-wl-close{border:0;background:transparent;color:inherit;font-size:22px;line-height:1;cursor:pointer;padding:0 2px}' +
    '.efp2-wl-body{padding:14px 20px 28px;overflow-y:auto;flex:1}' +
    '.efp2-wl-empty{opacity:.72;font-size:14px;line-height:1.6;margin:22px 0}' +
    '.efp2-wl-item{display:grid;grid-template-columns:74px 1fr auto;gap:12px;align-items:center;padding:12px 0;' +
    'border-bottom:1px solid var(--border--color-light,rgba(0,0,0,.12))}' +
    '.efp2-wl-item img{width:74px;height:98px;object-fit:cover;display:block;background:var(--bg-color--light,#f4f4f4)}' +
    '.efp2-wl-item a{color:inherit;text-decoration:none}' +
    '.efp2-wl-item-title{font-size:14px;line-height:1.35;display:block;margin-bottom:4px}' +
    '.efp2-wl-item-price{font-size:13px;opacity:.75}' +
    '.efp2-wl-remove{border:0;background:transparent;color:inherit;opacity:.55;cursor:pointer;font-size:18px;line-height:1;padding:4px}' +
    '.efp2-wl-remove:hover{opacity:1}' +
    '.efp2-wl-foot{padding:14px 20px 22px;font-size:12px;opacity:.6;line-height:1.5}';

  function injectCSS() {
    if (document.getElementById('efp2-wl-css')) { return; }
    var s = document.createElement('style');
    s.id = 'efp2-wl-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  /* ---------- 面板 ---------- */
  var panel, overlay, listEl, countEls = [];
  function buildUI() {
    overlay = document.createElement('div');
    overlay.className = 'efp2-wl-overlay';
    overlay.addEventListener('click', closePanel);

    panel = document.createElement('aside');
    panel.className = 'efp2-wl-panel';
    panel.setAttribute('aria-hidden', 'true');
    panel.innerHTML =
      '<div class="efp2-wl-head"><h2>Your list</h2>' +
      '<button type="button" class="efp2-wl-close" aria-label="Close your list">&times;</button></div>' +
      '<div class="efp2-wl-body"><div class="efp2-wl-list"></div></div>' +
      '<div class="efp2-wl-foot">Saved on this device only.</div>';
    panel.querySelector('.efp2-wl-close').addEventListener('click', closePanel);
    listEl = panel.querySelector('.efp2-wl-list');

    document.body.appendChild(overlay);
    document.body.appendChild(panel);
  }
  function openPanel() {
    renderList();
    overlay.classList.add('is-open');
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  }
  function closePanel() {
    overlay.classList.remove('is-open');
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }

  function renderList() {
    var handles = readList();
    if (!handles.length) {
      listEl.innerHTML = '<p class="efp2-wl-empty">Nothing saved yet.<br>Tap the heart on any shirt and it will wait for you here.</p>';
      return;
    }
    listEl.innerHTML = '';
    handles.forEach(function (h) {
      var row = document.createElement('div');
      row.className = 'efp2-wl-item';
      row.innerHTML = '<img alt="" loading="lazy"><div class="efp2-wl-meta">' +
        '<a class="efp2-wl-item-title" href="/products/' + h + '">' + h + '</a>' +
        '<span class="efp2-wl-item-price"></span></div>' +
        '<button type="button" class="efp2-wl-remove" aria-label="Remove from your list">&times;</button>';
      row.querySelector('.efp2-wl-remove').addEventListener('click', function () {
        writeList(readList().filter(function (x) { return x !== h; }));
        renderList();
      });
      listEl.appendChild(row);
      productData(h, function (d) {
        if (!d || !row.parentNode) { return; }
        var img = row.querySelector('img');
        if (d.image) { img.src = d.image; img.alt = d.title; }
        else { img.remove(); }
        var t = row.querySelector('.efp2-wl-item-title');
        t.textContent = d.title; t.href = d.url;
        row.querySelector('.efp2-wl-item-price').textContent = d.price;
      });
    });
  }

  function refreshCount() {
    var n = readList().length;
    countEls.forEach(function (el) {
      el.textContent = n;
      if (n) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
    });
  }

  /* ---------- header ♥ ---------- */
  function mountHeader() {
    var nav = document.querySelector('.header--secondary-nav') || document.querySelector('.header--root');
    if (!nav || nav.querySelector('.efp2-wl-header')) { return; }
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'efp2-wl-header';
    b.setAttribute('aria-label', 'Open your list');
    b.innerHTML = heartSVG(false) + '<span class="efp2-wl-count" hidden>0</span>';
    b.addEventListener('click', openPanel);
    nav.appendChild(b);
    countEls.push(b.querySelector('.efp2-wl-count'));
  }

  /* ---------- 商品卡心心（v2：放喺價錢行右手邊＝相下面資料列右下角；無價錢行才回退疊圖）---------- */
  function mountCards() {
    var cards = document.querySelectorAll('.product-card--root[data-handle]');
    Array.prototype.forEach.call(cards, function (card) {
      if (card.querySelector('.efp2-wl-heart')) { return; }
      var h = card.getAttribute('data-handle');
      if (!h) { return; }
      var details = card.querySelector('.product-card--details');
      var priceBox = details ? details.querySelector('.product--price-container') : null;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'efp2-wl-heart' + (details ? ' efp2-wl-card' : '');
      b.setAttribute('data-handle', h);
      b.setAttribute('aria-pressed', has(h) ? 'true' : 'false');
      b.setAttribute('aria-label', 'Save to your list');
      b.innerHTML = heartSVG(has(h));
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var added = toggle(h);
        b.setAttribute('aria-pressed', added ? 'true' : 'false');
        b.innerHTML = heartSVG(added);
      });
      if (details && priceBox) {
        details.classList.add('efp2-wl-details');
        details.appendChild(b);
      } else {
        if (getComputedStyle(card).position === 'static') { card.style.position = 'relative'; }
        card.appendChild(b);
      }
    });
  }

  /* ---------- 產品頁心心（v3：主題嘅產品頁價錢格係 .product-price--root，唔係 .product--price-container）---------- */
  function isVisible(el) {
    if (!el) { return false; }
    var r = el.getBoundingClientRect(), c = getComputedStyle(el);
    return r.width > 1 && r.height > 1 && c.visibility !== 'hidden' && c.display !== 'none';
  }
  function visibleFirst(list) {
    for (var i = 0; i < (list ? list.length : 0); i++) { if (isVisible(list[i])) { return list[i]; } }
    return null;
  }
  function mountProduct() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!m) { return; }
    if (document.querySelector('.efp2-wl-inline')) { return; }
    var h = decodeURIComponent(m[1]);
    /* ⚠️ 全頁有幾個同名價錢格（相關產品卡／搜尋預覽都係隱藏嘅）→ 一定要揀「客人真正睇到」嗰個 */
    var pr = visibleFirst(document.querySelectorAll('.product-price--root, .product--price-container'));
    if (!pr) { return; }
    var host = pr.closest('.product-form--block') || pr;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'efp2-wl-heart efp2-wl-card efp2-wl-inline efp2-wl-pd';
    b.setAttribute('aria-pressed', has(h) ? 'true' : 'false');
    b.setAttribute('aria-label', 'Save to your list');
    b.innerHTML = heartSVG(has(h));
    b.addEventListener('click', function () {
      var added = toggle(h);
      b.setAttribute('aria-pressed', added ? 'true' : 'false');
      b.innerHTML = heartSVG(added);
    });
    host.classList.add('efp2-wl-pdhost');
    host.appendChild(b);
  }

  /* 主題用 AJAX 重畫產品格（排序／篩選／換頁）之後，心心唔會跟住出現 → 加個觀察器自動補掛 */
  function watchGrid() {
    if (!window.MutationObserver || !document.body) { return; }
    var queued = false;
    new MutationObserver(function () {
      if (queued) { return; }
      queued = true;
      setTimeout(function () { queued = false; try { mountCards(); mountProduct(); refreshCount(); } catch (e) {} }, 250);
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- 手機版 header 排位：把日夜掣搬去左邊（Ben 2026-10-16 指定）----------
     原因：手機右邊要放「帳戶／購物袋／心心」三個掣，日夜掣留喺右邊會逼到冇位。 */
  var MQ = null;
  function layoutHeader() {
    try {
      var scheme = document.querySelector('button.header--scheme');
      var primary = document.querySelector('.header--primary-nav');
      var secondary = document.querySelector('.header--secondary-nav');
      if (!scheme || !primary || !secondary) { return; }
      if (!MQ) { MQ = window.matchMedia('(max-width: 767px)'); }
      if (MQ.matches) {
        if (primary.lastElementChild !== scheme) { primary.appendChild(scheme); }
      } else if (scheme.parentElement !== secondary) {
        secondary.insertBefore(scheme, secondary.firstChild);
      }
    } catch (e) { /* 冇呢啲元素就唔做 */ }
  }
  var rsT = null;
  function watchResize() {
    window.addEventListener('resize', function () {
      clearTimeout(rsT);
      rsT = setTimeout(layoutHeader, 200);
    });
  }

  /* ---------- 啟動 ---------- */
  function boot() {
    injectCSS();
    if (!panel) { buildUI(); }
    layoutHeader();
    watchResize();
    mountHeader();
    mountCards();
    mountProduct();
    refreshCount();
    watchGrid();
    window.addEventListener('efp2-wishlist-change', refreshCount);
    document.addEventListener('click', function () { /* 保留：主題 AJAX 換頁時可再掛 */ });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  /* 主題用 transition／AJAX 換 collection 內容 → 遲一步再掛一次 */
  setTimeout(function () { try { layoutHeader(); mountCards(); refreshCount(); } catch (e) {} }, 1200);
})();
